//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import cmBlank from '@/components/cmBlank';
import cmLoadmore from '@/components/cmLoadmore.vue'

export default {
     components: {
        cmBlank,cmLoadmore
    },
    data(){
        return {
            blankShow:false,
            height:'100%',
            isActive:1,
            checkAllStatus: 0,
            checkAllWithdraw: 0,
            loadStatus:false,
            loadmoreText:'正在加载。。。',
            busy:false,
            list:[],
            where:[],
            hasNext:0,
            pageFlag:2,
            lastId:0,
            grade:0,
            money:0,
            types:[
                {
                    'key':0,
                    'text':'提现记录',
                },
                {
                    'key':1,
                    'text':'可提现订单',
                },
            ],
            info:{
                wait_withdraw:0.00,
                total_withdraw:0.00,
            },
            moneyMax:5000,
            // countMoney:0
        }
    },
    mounted(){
        // this.getList();
        this.withdrawMoney();
    },
    methods: {
        select(i){
            this.where = [];
            this.isActive = i;
            this.lastId = 0;
            this.hasNext = 0;
            this.list = [];
            this.loadmore();
        },
        resetSearch(){
            this.list = [];
            this.where = [];
            this.getList();
        },
        check(i){
            if(this.list[i].checked > 0){
                this.money = (Number(this.money) - Number(this.list[i].money)).toFixed(2);
                this.list[i].checked = 0;
            }else{
                if((Number(this.money) + Number(this.list[i].money)) <= this.moneyMax){
                    this.list[i].checked = 1;
                    this.money = (Number(this.money) + Number(this.list[i].money)).toFixed(2);
                }else{
                    this.$func.showToast('单笔最高可提现 '+this.moneyMax+' 元');
                    return false;
                }
            }
        },
        // countMoney(){
        //     let that = this;
        //     this.money = 0;
        //     if(this.checkAllStatus){
        //         this.money = this.info.wait_withdraw;
        //     }else{
        //         that.list.forEach((item,index)=>{
        //             if(item.checked && Number(item.status) == 1){
        //                 that.money = (Number(that.money) + Number(item.money)).toFixed(2);
        //             }
        //         })
        //     }
        // },
        checkAll(){
            this.checkAllStatus = !this.checkAllStatus;
            this.money = 0;
            if(this.checkAllStatus){
                this.list.forEach((item,index)=>{
                    if((Number(this.money) + Number(item.money)) <= this.moneyMax){
                        item.checked = 1;
                        this.money = (Number(this.money) + Number(item.money)).toFixed(2);
                    }else{
                        item.checked = 0;
                    }
                })
                // this.money = this.info.wait_withdraw;
                // this.money = money;
            }else{
                this.list.forEach((item,index)=>{
                    item.checked = 0;
                })
            }
            // this.countMoney();
        },
        getList(){
            let that = this;
            // this.loadmoreText = '正在加载。。。';
            switch(parseInt(that.isActive)){
                case 1:
                     this.$api.withdrawList({last_id:this.lastId,page_flag:this.pageFlag}).then((res)=>{
                    if(res){
                        if(!this.lastId){
                            this.blankShow = res.data.length > 0 ? false : true;
                        }
                        this.hasNext = res.hasNext;
                        this.lastId = res.lastId;
                        res.data.forEach((item)=>{
                            if(this.checkAllWithdraw){
                                item.checked = 1;
                            }else{
                                if(this.checkAllStatus){
                                    if((Number(this.money) + Number(item.money)) <= this.moneyMax){
                                        this.money = (Number(this.money) + Number(item.money)).toFixed(2);
                                        item.checked = 1;
                                    }
                                }
                            }
                            this.list.push(item);
                        });
                        // this.checkAllStatus = false;
                    }
                });
                break;
                default:
                this.$api.withdrawRecord({last_id:this.lastId,page_flag:this.pageFlag,type:0}).then((res)=>{
                        if(res){
                            if(!this.lastId){
                                this.blankShow = res.data.length > 0 ? false : true;
                            }
                            this.hasNext = res.hasNext;
                            this.lastId = res.lastId;
                            res.data.forEach((item)=>{
                                this.list.push(item);
                            });
                        }
                    });
                break;
            }
        },
         withdrawMoney(){
            this.$api.withdrawMoney({}).then((res)=>{
                if(res){
                    this.info = res.data;
                }
            });
        },
        allWithdraw(){
            if(this.info.wait_withdraw <= this.moneyMax){
                this.money = Number(this.info.wait_withdraw).toFixed(2);
                this.checkAllWithdraw = 1;
                this.checkAllStatus = 1;
                this.list.forEach((item,index)=>{
                    item.checked = 1;
                })
            }else{
                this.$func.showToast('可提现金额大于单次提现限额，请手动选择提现订单');
            }
        },
        withdraw() {
            if(this.money <= 0){
                this.$func.showToast('请选择提现订单');
                return false;
            }
            if(this.money > this.moneyMax){
                this.$func.showToast('单次提现限额'+this.moneyMax+'元');
                return false;
            }
            let ids = '';
            if(Number(this.money) != Number(this.info.wait_withdraw)){
                this.list.forEach((item,index) => {
                    if(item.checked && Number(item.status) == 1){
                        ids += item.id+',';
                    }
                });
            }
            // if(!this.checkAllStatus){
               
            // }
            // if(!ids){
            //     this.$func.showToast('请选择提现订单');
            //     return false;
            // }
            this.$router.push({path: '/withdraw', query: {ids:ids,type:0}});
        },
         loadmore(){
            if(this.lastId > 0 && !this.hasNext){
                this.busy = true;
                this.loadStatus = true;
                this.loadmoreText = '没有更多了。。。'
                return ;
            }
            this.busy = true;
            this.loadStatus = true;
            this.loadmoreText = '正在加载。。。';
            // console.log(1111);
            this.getList();
            setTimeout(()=>{
            if(this.blankShow){
                    this.busy = true;
                    this.loadStatus = false;
                    this.loadmoreText = '没有更多了。。。'
                }else{
                    if(this.hasNext > 0){
                        this.loadStatus = false;
                        this.busy = false;
                    }else{
                        this.busy = true;
                        this.loadStatus = true;
                        this.loadmoreText = '没有更多了。。。'
                    }
                }
            },1500)
        }
    },
}



// WEBPACK FOOTER //
// ./src/pages/withdrawRecord.vue